import Price from '../lakeview/Price';

const columns = [

    {
        label: "Nazwa",
        field: "label",
        width: 200,
    },
    {
        label: "Wartość",
        field: "value",
        width: 53,
        type: "custom",
        custom: (column, row) => {
            if (row?.type === "PERCENTAGE_SCALE_4") {
                return `${row.value} %`;
            }

            if (row?.type === "PRICE") {
                return <Price value={row.value} />;
            }

            if (row?.type === "BOOLEAN") {
                return row.value==="true" ? "Tak" : "Nie";
            }
            return row.value;
        }
    },
]

export default columns;